import { Button } from "../../../../components";
import { HeavyCheckIcon } from "../../../../assets/icons";

interface SubmissionSuccessViewProps {
  onGoBack: () => void;
}

const SubmissionSuccessView = ({ onGoBack }: SubmissionSuccessViewProps) => {
  return (
    <div className="cx-grow cx-w-full cx-flex cx-flex-col cx-items-center cx-justify-center cx-px-4 sm:cx-px-6">
      <HeavyCheckIcon />
      <div className="cx-text-text-primary cx-font-bold cx-text-3xl cx-text-center cx-my-2">
        Thank you!
      </div>
      <div className="cx-text-text-secondary cx-text-center cx-mb-8 cx-max-w-md">
        Thanks for the update. We are reviewing your application. <br /> We will
        get back to you soon with the offer.
      </div>
      <div className="cx-w-full cx-max-w-sm">
        <Button
          label={"OK, Go back to dashboard"}
          slim={true}
          fullWidth
          className={"cx-font- cx-text-s"}
          onClick={onGoBack}
        />
      </div>
    </div>
  );
};

export default SubmissionSuccessView;
